export const formatTimestamp = timestamp => {
  if (!timestamp) {
    return 'N/A';
  }

  const date = new Date(timestamp * 1000);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

  const timezoneOffset = date.getTimezoneOffset();
  const tzHours = Math.abs(Math.floor(timezoneOffset / 60));
  const tzMinutes = Math.abs(timezoneOffset % 60);
  const sign = timezoneOffset <= 0 ? '+' : '-';
  const timezone = `UTC${sign}${tzHours.toString().padStart(2, '0')}:${tzMinutes.toString().padStart(2, '0')}`;

  return `${formattedDate} (${timezone})`;
};

export const formatRelativeTime = timestamp => {
  if (!timestamp) {
    return '';
  }

  const now = new Date();
  const date = new Date(timestamp * 1000);
  const diffMs = now - date;

  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffDay > 0) {
    return diffDay === 1 ? `1 day ago` : `${diffDay} days ago`;
  } else if (diffHour > 0) {
    const mins = diffMin % 60;
    if (mins > 0) {
      return diffHour === 1
        ? `1 hour ${mins} min${mins === 1 ? '' : 's'} ago`
        : `${diffHour} hours ${mins} min${mins === 1 ? '' : 's'} ago`;
    } else {
      return diffHour === 1 ? `1 hour ago` : `${diffHour} hours ago`;
    }
  } else if (diffMin > 0) {
    return diffMin === 1 ? `1 minute ago` : `${diffMin} minutes ago`;
  } else {
    return `just now`;
  }
};

export const convertUtcToLocal = (hours, minutes, seconds) => {
  try {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = now.getUTCMonth();
    const day = now.getUTCDate();

    const utcDate = new Date(
      Date.UTC(year, month, day, parseInt(hours, 10), parseInt(minutes, 10), parseFloat(seconds))
    );

    return utcDate.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
      hour12: false,
    });
  } catch (error) {
    console.error('Error converting to local time:', error);
    return 'Unknown';
  }
};

export const formatUptime = milliseconds => {
  if (!milliseconds || isNaN(milliseconds)) {
    return 'N/A';
  }

  let totalSeconds = Math.floor(milliseconds / 1000);

  const days = Math.floor(totalSeconds / (24 * 3600));
  totalSeconds %= 24 * 3600;

  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const parts = [];
  if (days > 0) {
    parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
  }
  if (hours > 0) {
    parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`);
  }
  if (seconds > 0 || parts.length === 0) {
    parts.push(`${seconds} ${seconds === 1 ? 'second' : 'seconds'}`);
  }
  return parts.join(' ');
};
